var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("el-cascader", {
            ref: "cascader",
            staticStyle: { width: "100%" },
            attrs: {
              placeholder: "输入文字搜索",
              options: _vm.orgList,
              props: _vm.props,
              clearable: "",
              filterable: "",
              "show-all-levels": false,
              disabled: _vm.disabled
            },
            on: { change: _vm.changeValue },
            model: {
              value: _vm.selOrgId,
              callback: function($$v) {
                _vm.selOrgId = $$v
              },
              expression: "selOrgId"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2146d8b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2146d8b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/drop-down-organize-tree.vue
// module id = null
// module chunks = 